<template>
  <div>
    <div style="display: flex; flex-direction: row">
      <span>
        <v-btn text icon color="black" v-on:click="caricaDati">
          <v-icon>refresh</v-icon>
        </v-btn>
      </span>

      <span>
        <v-switch v-model="swFatturato" label="Filtra per fatturato" class="pl-3 pb-2 mt-1" hide-details color="primary"
          v-on:change="cambiaFiltro"></v-switch>

        <v-flex xs6 sm6>
          <v-select return-object outlined label="Tipologia" no-data-text="Nessun dato" :items="tipi" v-model="tipo"
            item-text="value" v-on:input="cambiaTipologia()" style="width: 150px; max-width: 150px">
            <template v-slot:item="{ item }">
              <template>
                <v-list class="ma-0 pa-0">
                  <v-row no-gutters class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0">
                      <v-list-item class="ma-0 pa-0">
                        <img :src="item.image" style="max-width: 28px" class="mr-3" />
                        <span>{{ item.value }}</span>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list>
              </template>
            </template>
          </v-select>
        </v-flex>
      </span>

      <span v-if="swFatturato">
        <div style="
            margin-bottom: 0px;
            margin-top: 12px;
            font-size: 0.9em;
            padding-top: 10px;
          ">
          (Il fatturato è stato generato dagli ordini consegnati negli ultimi 12
          mesi)
        </div>
      </span>
      <v-spacer></v-spacer>

      <v-text-field append-icon="search" label="Cerca indirizzo" class="mt-0" single-line hide-details
        v-model="indirizzo" clearable style="min-width: 40%; margin-bottom: -5px; padding-bottom: -5px"
        @click:append="cerca()" v-on:keyup.enter="cerca()">
      </v-text-field>
    </div>

    <div>
      <div style="width: 100%; height: 100%">
        <div class="google-map mb-15" :id="mapName"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_mapsClienti /* get_mapsProvince */ } from "@/api/api.agenti.js";
/* import { geoxml3 } from "@/assets/lib/geoxml3-master/kmz/geoxml3.js"; */

/**
 * https://sites.google.com/site/gmapsdevelopment/
 */
export default {
  name: "google-map",

  props: {
    name: {
      type: String,
      default: "",
    },
  },

  data: function () {
    return {
      mapName: "google-map",
      inputAddress: "pac-input",
      markerCoordinates: [],
      map: null,
      bounds: null,
      infoWindow: null,
      markers: [],
      markersYou: [],
      indirizzo: "",
      markerColor: "",
      showroomMColor:
        this.$load.getUrlImg() + "\\mappe\\pointers\\showroom.png",
      clientiMColor: this.$load.getUrlImg() + "\\mappe\\pointers\\cliente.png",
      image: {
        url: this.$load.getUrlImg() + "\\mappe\\pointers\\utente.png",
        size: null,
      },
      tipi: [
        { item: "tutti", value: "tutti", image: "" },
        {
          item: "showroom",
          value: "showroom",
          image: this.$load.getUrlImg() + "\\mappe\\pointers\\showroom.png",
        },
        {
          item: "clienti",
          value: "clienti",
          image: this.$load.getUrlImg() + "\\mappe\\pointers\\cliente.png",
        },
      ],
      tipo: { item: "tutti", value: "tutti", image: "" },
      styles: this.returnStyle(),

      swFatturato: false,
      autocomplete: null,
    };
  },

  methods: {
    returnStyle() {
      return [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#444444",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              color: "#f2f2f2",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 45,
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [
            {
              color: "#dde6e8",
            },
            {
              visibility: "on",
            },
          ],
        },
      ];
    },

    caricaMappa() {
      // ----- Pulizia ------
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];

      for (i = 0; i < this.markersYou.length; i++) {
        this.markersYou[i].setMap(null);
      }
      this.markersYou = [];

      // --------------

      if (this.map == null) {
        // eslint-disable-next-line no-undef
        this.bounds = new google.maps.LatLngBounds();

        // eslint-disable-next-line no-undef
        this.infoWindow = new google.maps.InfoWindow();

        const element = document.getElementById(this.mapName);
        const options = {
          componentRestrictions: { country: "it" },
          mapTypeId: "roadmap",
          styles: this.styles,
        };
        // eslint-disable-next-line no-undef
        this.map = new google.maps.Map(element, options);
        this.map.setOptions({ minZoom: 5, maxZoom: 20 });
        this.map.setZoom(6);
      }

      let tipoSel = 2;
      if (this.tipo.item == "showroom") tipoSel = 1;
      else if (this.tipo.item == "clienti") tipoSel = 0;
      this.markers = [];

      this.markerColor = "";
      // Ciclo sulle coordinate
      this.markerCoordinates.forEach((coord) => {
        if (tipoSel == 2 || tipoSel == coord.Esposizione) {
          let visible = false;
          if (this.swFatturato) {
            if (coord.Esposizione == 1) {
              if (
                coord.Fatturato < 5000 &&
                (this.tipo.item == "tutti" || this.tipo.item == "rosso")
              ) {
                this.markerColor =
                  this.$load.getUrlImg() +
                  "\\mappe\\pointers\\showroom-rosso.png";
                visible = true;
              } else if (
                coord.Fatturato >= 5000 &&
                coord.Fatturato <= 15000 &&
                (this.tipo.item == "tutti" || this.tipo.item == "giallo")
              ) {
                this.markerColor =
                  this.$load.getUrlImg() +
                  "\\mappe\\pointers\\showroom-giallo.png";
                visible = true;
              } else if (
                coord.Fatturato > 15000 &&
                (this.tipo.item == "tutti" || this.tipo.item == "verde")
              ) {
                this.markerColor =
                  this.$load.getUrlImg() +
                  "\\mappe\\pointers\\showroom-verde.png";
                visible = true;
              }
            } else if (coord.Esposizione == 0) {
              if (
                coord.Fatturato < 5000 &&
                (this.tipo.item == "tutti" || this.tipo.item == "rosso")
              ) {
                this.markerColor =
                  this.$load.getUrlImg() +
                  "\\mappe\\pointers\\cliente-rosso.png";
                visible = true;
              } else if (
                coord.Fatturato >= 5000 &&
                coord.Fatturato <= 15000 &&
                (this.tipo.item == "tutti" || this.tipo.item == "giallo")
              ) {
                this.markerColor =
                  this.$load.getUrlImg() +
                  "\\mappe\\pointers\\cliente-giallo.png";
                visible = true;
              } else if (
                coord.Fatturato > 15000 &&
                (this.tipo.item == "tutti" || this.tipo.item == "verde")
              ) {
                this.markerColor =
                  this.$load.getUrlImg() +
                  "\\mappe\\pointers\\cliente-verde.png";
                visible = true;
              }
            }
          } else {
            if (coord.Esposizione == 0) this.markerColor = this.clientiMColor;
            else if (coord.Esposizione == 1)
              this.markerColor = this.showroomMColor;
            visible = true;
          }

          if (visible && coord != undefined) {
            // eslint-disable-next-line no-undef
            const position = new google.maps.LatLng(
              coord.Latitudine,
              coord.Longitudine
            );

            // eslint-disable-next-line no-undef
            const marker = new google.maps.Marker({
              position,
              map: this.map,
              icon: { url: this.markerColor },
            });

            this.map.fitBounds(this.bounds.extend(position));

            let self = this;

            // Fumetto
            // eslint-disable-next-line no-undef
            google.maps.event.addListener(marker, "click", async function () {
              let message = coord.ClRagSoc;
              if (self.swFatturato) {
                message += "<br> Fatturato: €" + coord.Fatturato;
                let res = await get_mapsClienti("dettaglio/" + coord.ClCodCli);
                if (res != null && res.data != null && res.data != undefined)
                  message +=
                    "<div><hr>MPM Porte: €" +
                    res.data.MpmPorte +
                    "<br>MPM Arredo: €" +
                    res.data.MpmArredo +
                    "<br>MPM Sicur: €" +
                    res.data.MpmSicur +
                    "<hr>Agente: " +
                    coord.NomeAgente +
                    "</div>";
              }
              self.infoWindow.setContent(message);
              self.infoWindow.open(self.map, this);
            });

            // Inserisco il marker
            this.markers.push(marker);
          }
        }
      });
    },

    async caricaDati() {
      // Reset
      this.markerCoordinates = [];

      let par = "";
      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;

      let res = await get_mapsClienti(par);
      if (res == null || this.markerCoordinates == undefined) return;
      this.markerCoordinates = res.data;
      this.caricaMappa();
      this.map.setZoom(6);
      await this.centerMapItaly();
    },

    cerca() {
      for (let i = 0; i < this.markersYou.length; i++) {
        this.markersYou[i].setMap(null);
      }
      this.markersYou = [];

      var markerYou = null;
      // eslint-disable-next-line no-undef
      var geocoder = new google.maps.Geocoder();
      const self = this;
      geocoder.geocode({ address: self.indirizzo }, function (results, status) {
        // eslint-disable-next-line no-undef
        if (status == google.maps.GeocoderStatus.OK) {
          var center = results[0].geometry.location;
          // eslint-disable-next-line no-undef
          self.image.size = new google.maps.Size(60, 96);
          // eslint-disable-next-line no-undef
          markerYou = new google.maps.Marker({
            map: self.map,
            icon: self.image,
            position: center,
          });

          self.markersYou.push(markerYou);
          self.map.setZoom(15);
          self.map.panTo(center);

          // eslint-disable-next-line no-undef
          google.maps.event.addListener(markerYou, "click", function () {
            self.infoWindow.setContent("<b>LOCALITÀ SELEZIONATA</b>");
            self.infoWindow.open(this.map, markerYou);
          });
        } else {
          self.$toast.warning(self.indirizzo + "\n località non trovata");
        }
      });
    },

    async cambiaFiltro() {
      if (this.swFatturato) {
        this.tipi.pop();
        this.tipi.pop();
        this.tipo = { item: "tutti", value: "tutti", image: "" };
        this.tipi.push(
          {
            item: "verde",
            value: "oltre 15.000€",
            image:
              this.$load.getUrlImg() + "\\mappe\\pointers\\cliente-verde.png",
          },
          {
            item: "giallo",
            value: "tra 5.000€ e 15.000€",
            image:
              this.$load.getUrlImg() + "\\mappe\\pointers\\cliente-giallo.png",
          },
          {
            item: "rosso",
            value: "meno di 5.000€",
            image:
              this.$load.getUrlImg() + "\\mappe\\pointers\\cliente-rosso.png",
          }
        );
      } else {
        this.tipi = [
          { item: "tutti", value: "tutti", image: "" },
          {
            item: "showroom",
            value: "showroom",
            image: this.$load.getUrlImg() + "\\mappe\\pointers\\showroom.png",
          },
          {
            item: "clienti",
            value: "clienti",
            image: this.$load.getUrlImg() + "\\mappe\\pointers\\cliente.png",
          },
        ];
      }
      await this.caricaMappa();

      await this.centerMapItaly();
    },

    async cambiaTipologia() {
      await this.caricaMappa();
      await this.centerMapItaly();
    },

    async centerMapItaly() {
      await this.map.panTo(
        // eslint-disable-next-line no-undef
        new google.maps.LatLng(42.403516412008976, 11.1472753585981)
      );
      await this.map.setZoom(6);
    },

    /* async caricaMappaProvince() {
      const element = document.getElementById("mappaProva");
      const options = {
        componentRestrictions: { country: "it" },
        mapTypeId: "roadmap",
        styles: this.styles,
      };
      // eslint-disable-next-line no-undef
      let mappa = new google.maps.Map(element, options);

      //errore su libreria --> provare a importare da assets/lib/geoxml3.js
      var myParser = new geoxml3.parser({ map: mappa });

      let res = await get_mapsProvince();
      let str = res.data;
      myParser.parseKmlString(str);
    }, */
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);

    await this.caricaDati();
    //visualizzo la mappa con l'Italia centrata
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
  },

  watch: {
    userSwitch() {
      this.caricaDati();
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 1000px;
  margin: 0 auto;
  background: gray;
  color: black;
}
</style>